import React from 'react';
import { Card, Text, Box, Button } from '@shopify/polaris';
import { useI18n } from '../i18n';

// The error card is a function component so it can read the i18n context
// (ErrorBoundary itself is a class and cannot use hooks); the boundary stays
// above it in the tree, so the context is available even while crashing.
function ErrorFallback({ error }) {
  const { t } = useI18n();
  return (
    <Card>
      <Box padding="400">
        <Text variant="headingSm" as="h2">{t('error.title')}</Text>
        <Box paddingBlockStart="200">
          <Text variant="bodySm" as="p" tone="subdued" breakWord>
            {String(error && error.message)}
          </Text>
        </Box>
        <Box paddingBlockStart="300">
          <Button onClick={() => window.location.reload()}>{t('error.reload')}</Button>
        </Box>
      </Box>
    </Card>
  );
}

// Keeps a render crash from blanking the whole embedded app: show the error
// and a reload button instead of an empty root.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return <ErrorFallback error={this.state.error} />;
    }
    return this.props.children;
  }
}
